class TabButton extends HTMLElement {
    state;
    constructor() {
        super();
    }

    connectedCallback() {
        let id = this.getAttribute('for');
        let group = this.getAttribute('group');
        
        let tab_buttons = document.querySelectorAll('tab-button[group="' + group + '"]');
        tab_buttons.forEach(button =>{
            if (button.hasAttribute('is-open') == false){
                button.setAttribute('is-closed', '');
            }
        });


        this.addEventListener('click', () => {
            let attribute_id = '[id="' + id + '"]';
            let button_id = '[for="' + id + '"]';
            let selected_tab = document.querySelector(attribute_id);
            let selected_tab_button = document.querySelector(button_id);
            let tab_buttong = document.querySelectorAll('tab-button[group="' + group + '"]');


            if (selected_tab.hasAttribute('single-tab-closable')){
                let tabs = document.querySelectorAll('tab-content[group="' + group + '"]');
                tabs.forEach(tab =>{
                    if (tab != selected_tab){
                        if (tab.hasAttribute('is-open')){
                            tab.removeAttribute('is-open');
                        }
                    }
                })
                tab_buttong.forEach(button =>{
                    if (button != selected_tab_button){
                        if (button.hasAttribute('is-open')){
                            button.removeAttribute('is-open');
                            button.setAttribute('is-closed', '');
                        }
                    }
                })

                if (selected_tab.hasAttribute('is-open')){
                    selected_tab.removeAttribute('is-open');
                    selected_tab_button.removeAttribute('is-open');
                    selected_tab_button.setAttribute('is-closed', '');
                }
                else {
                    //selected_tab_button.scrollIntoView({ behavior: 'smooth', block: 'start' }); // 'start' aligns the element at the top of the viewport
                    var elementOffsetTop = selected_tab_button.getBoundingClientRect().top;
                    window.scrollTo({
                        top: window.scrollY + elementOffsetTop - 70, // Subtract for the offset of the floating menu
                        behavior: 'smooth'
                    });
                    selected_tab.setAttribute('is-open', '');
                    selected_tab_button.removeAttribute('is-closed');
                    selected_tab_button.setAttribute('is-open', '');
                }
            }

            else {
                let tabs = document.querySelectorAll('tab-content[group="' + group + '"]');
                tabs.forEach(tab =>{
                    if (tab.hasAttribute('is-open')){
                        tab.removeAttribute('is-open');
                    }
                })
                tab_buttong.forEach(button =>{
                    if (button.hasAttribute('is-open')){
                        button.removeAttribute('is-open');
                        button.setAttribute('is-closed', '');
                    }
                })
                selected_tab.setAttribute('is-open', '');
                if (selected_tab_button.hasAttribute('is-closed')){
                    selected_tab_button.removeAttribute('is-closed');
                }
                selected_tab_button.setAttribute('is-open', '');
            }
        })
    }
}
customElements.define('tab-button', TabButton);

customElements.define('tab-content', class extends HTMLElement{});